import React from 'react';
import { CarrierEditViewStore } from 'modules/carrier/stores';
import { CarrierEditTemplate } from 'themes/modules/carrier/pages';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new CarrierEditViewStore(rootStore, componentProps), 'carrierEditViewStore')
class CarrierEdit extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <CarrierEditTemplate {...this.props} />;
	}
}

export default CarrierEdit;



// WEBPACK FOOTER //
// ./src/modules/carrier/pages/CarrierEdit.jsx